import React from 'react';
import { ColumnProps } from '@common-ui-library/molecule';
import { Box } from '@common-ui-library/atom';
import { Site } from '../../Utils/types';

interface SiteColumnPropsType extends ColumnProps {
  exportValue?: (site: Site) => string;
}

const siteColumnProps: SiteColumnPropsType[] = [
  {
    key: 'displayName',
    header: 'Name',
    width: '60%',
    exportValue: (site: Site) => site?.name ?? '',
    render: (site: Site) => {
      return <Box>{site?.name}</Box>;
    },
  },
  {
    key: 'timezone',
    header: 'Timezone',
    width: '40%',
  },
];

export default siteColumnProps;
